import { dynamicSort } from '@/shared/utils/dynamicSort';
import guid, { guid1 } from '@/shared/utils/guid';
import angular from 'angular';

angular.module('cloudX').directive('cxUserTypeahead', [
  'dataCache',
  '$translate',
  function(dataCache, $translate) {
    return {
      restrict: 'E',
      replace: true,
      template: `<div class="dropdown" uib-dropdown ng-show="options.length" is-open="ddwOpen">
        <div class="input-group">
          <input type="text"
                 ng-model="selected"
                 uib-typeahead="item as item.label for item in allOptions | filter:$viewValue | limitTo:limit "
                 typeahead-min-length="0" typeahead-select-on-blur="selectOnBlur"
                 typeahead-select-on-exact="selectOnExact"
                 typeahead-on-select="onSelect($item)"
                 typeahead-template-url="userTypeaheadTemplate.html"
                 ng-blur="onBlur()"
                 ng-focus="ddwOpen=false"
                 class="form-control"
                 placeholder="{{placeholder}}"
                 autocomplete="off"/>
            <span class="input-group-btn">
              <button class="btn btn-default dropdown-toggle" uib-dropdown-toggle ng-if="!selected.id">
                <span class="caret"></span>
              </button>
              <button class="btn btn-default" ng-if="selected.id" ng-click="onSelect(null)">
                <span class="fa fa-times"></span>
              </button>
            </span>
        </div>
        <ul class="dropdown-menu dropdown-menu-right" role="menu" style="max-height:200px;overflow-y:auto">
          <li ng-show="currentUser" ng-class="{'active':selected===currentUser}">
            <a href ng-click="onSelect(currentUser)" data-translate="Me"></a>
          </li>
          <li ng-show="unassignedUser" ng-class="{'active':selected===unassignedUser}">
            <a href ng-click="onSelect(unassignedUser)" data-translate="Unassigned"></a>
          </li>
          <li ng-show="systemUser" ng-class="{'active':selected===systemUser}">
            <a href ng-click="onSelect(systemUser)" data-translate="SystemUser"></a>
          </li>
          <li ng-if="extraOptions" ng-repeat="op in extraOptions" ng-class="{'selected':op===selected, 'removed-user':!op.isActive}">
            <a href ng-click="onSelect(op)">{{op.label}}</a>
          </li>
          <li ng-show="currentUser || unassignedUser || systemUser || (extraOptions && extraOptions.lenght>0)" role="separator" class="divider"></li>
          <li ng-repeat="op in options" ng-class="{'selected':op===selected, 'removed-user':!op.isActive}">
            <a href ng-click="onSelect(op)">{{op.label}}</a>
          </li>
        </ul>
        <script type="text/ng-template" id="userTypeaheadTemplate.html">
          <a href
            tabindex="-1"
            ng-class="{'removed-user':!match.model.isActive}"
            ng-bind-html="match.label | sanitize | cxTypeaheadHighlight:query"
            ng-attr-title="{{match.label}}">
          </a>
        </script>
      </div>`,
      scope: {
        placeholder: '@?',
        showUnassigned: '@?',
        showSystemUser: '@?',
        extraOptions: '=?', //Make sure to only render control if the extraOptions are initialised. (ng-if="!!extraOptions")
      },
      require: 'ngModel',
      link: function($scope, el, attrs, ngModel) {
        if (!ngModel) return;
        $scope.unassignedUser = $scope.showUnassigned
          ? {
              id: guid.empty,
              label: $translate.instant('Unassigned'),
              isActive: true,
            }
          : null;
        $scope.systemUser = $scope.showSystemUser
          ? {
              id: guid1,
              label: $translate.instant('SystemUser'),
              isActive: true,
            }
          : null;

        $scope.options = dataCache
          .getArray('user')
          .filter(x => x.isActive || !x.hidden)
          .map(({ userID, firstName, lastName, isActive }) => ({
            id: userID,
            label: `${firstName} ${lastName}`,
            isActive,
          }))
          .sort(dynamicSort('label'));

        $scope.allOptions = [
          $scope.unassignedUser,
          $scope.systemUser,
          ...($scope.extraOptions || []).filter(x => x.id && x.label),
          ...$scope.options,
        ].filter(x => !!x);

        $scope.limit = $scope.$eval(attrs.limit) || 10;
        $scope.selectOnBlur = angular.isDefined(attrs.selectOnBlur)
          ? $scope.$eval(attrs.selectOnBlur) || attrs.selectOnBlur
          : true;
        $scope.selectOnExact = angular.isDefined(attrs.selectOnExact)
          ? $scope.$eval(attrs.selectOnExact) || attrs.selectOnExact
          : true;
        $scope.showAll = false;

        var findOption = function(id) {
          if (id == null || $scope.allOptions.length === 0) return null;

          return $scope.allOptions.find(function(el) {
            return el.id === id;
          });
        };

        $scope.currentUser = findOption(dataCache.getArray('employee').userID);

        $scope.onSelect = function(item) {
          if (item !== null) {
            $scope.selected = item;
            $scope.value = item.id;
            ngModel.$setViewValue(item.id);
          } else {
            $scope.value = null;
            $scope.selected = null;
            ngModel.$setViewValue(null);
          }
        };
        $scope.onBlur = function() {
          if ($scope.selected != null && $scope.selected.id != null) return;
          $scope.value = null;
          $scope.selected = null;
          ngModel.$setViewValue(null);
        };

        ngModel.$render = function() {
          $scope.value = ngModel.$viewValue;
          $scope.selected = findOption($scope.value);
        };
      },
    };
  },
]);
